import { Feature } from '@tencent/workbench';
import { SLIDE_ADAPTER } from '@src/framework/workbench/editor-adpater/slide-adapter';
import { IChartLineMarkerSeletorFeature, LinePanelType } from '@tencent/chart-drawer-components/lib/interface';
import FormSchemaLogic from '@src/slide/application/service/property-editor-manager/form-schema-logic';
import { getPcInjectedService } from '@src/framework/workbench/util/injector-service';
import { ChartService } from '@src/framework/workbench/common/service/chart-service';
import ChartBaseDrawerFeature from '@src/framework/workbench/drawer/ui/chart/chart-base-drawer-feature';

@Feature({
    name: 'ChartLineMarkerSeletorFeature',
    adapters: [SLIDE_ADAPTER],
    provide: IChartLineMarkerSeletorFeature,
})
export class ChartLineMarkerSeletorFeature extends ChartBaseDrawerFeature implements IChartLineMarkerSeletorFeature {
    public setLinePanelType = (panelType: LinePanelType) => {
        const model = this.getSelectModel();
        (getPcInjectedService(ChartService) as ChartService).setLinePanelType(panelType);
        const FORM_SCHEMA = FormSchemaLogic.getChartFormSchema(model);
        FormSchemaLogic.formService.setSchema(FORM_SCHEMA);
    };

    public resetPanel = () => {
        (getPcInjectedService(ChartService) as ChartService).setLinePanelType(LinePanelType.LINE);
    };
}
